import { client, gql } from 'data-provider';
import { IDamageGood } from 'interfaces';

export interface IAllDamageGoodsQuery {
  startDate?: string;
  endDate?: string;
  searchString?: string;
  start?: number;
  limit?: number;
}

export const getDamages = async (damagedQuery?: IAllDamageGoodsQuery) => {
  const where = {
    query: damagedQuery && damagedQuery.searchString ? damagedQuery.searchString : '',
    startDate: damagedQuery && damagedQuery.startDate ? damagedQuery.startDate : undefined,
    endDate: damagedQuery && damagedQuery.endDate ? damagedQuery.endDate : undefined,
  };
  const query = gql`
    query ($sort: SortInput, $where: JSON, $start: Int, $limit: Int) {
      damagesCopy(sort: $sort, where: $where, start: $start, limit: $limit) {
        data {
          id
          damageDate
          damageDetails
          totalAmount
          user {
            name
            email
            id
            mobileNumber
          }
          warehouse {
            id
            name
          }
          damageProductsCopy {
            id
            quantity
            lossAmount
            productVariant {
              id
              sku
              name
            }
          }
        }
        total
        size
        page
      }
    }
  `;

  const variables = {
    where,
    start: damagedQuery && damagedQuery.start ? damagedQuery.start : 1,
    limit: damagedQuery && damagedQuery.limit ? damagedQuery.limit : 10,
  };
  const data = await client.request(query, variables);
  return data.damagesCopy as {
    data: IDamageGood[];
    page: number;
    size: number;
    total: number;
  };
};
interface CreateDamageData {
  damageDate: Date;
  damageDetails: string;
  warehouse: string;
  damageProducts: {
    productVariant: string;
    quantity: number;
    lossAmount: number;
  }[];
  damageExpense: { id: string }[];
}

export const createDamage = async (data: CreateDamageData) => {
  const createDamage = gql`
    mutation ($input: createDamageCopyInput!) {
      createDamageCopy(input: $input) {
        id
      }
    }
  `;

  const variables = {
    input: { data },
  };

  const createdData = await client.request(createDamage, variables);
  return createdData;
};

export const getDamagesDropdown = async (startDate?: string, endDate?: string) => {
  const where = { startDate, endDate };

  const query = gql`
    query ($where: JSON) {
      damageDropdownCopy(where: $where) {
        id
        damageDate
        damageDetails
        totalAmount
        damageProductsCopy {
          id
          quantity
          lossAmount
          productVariant {
            id
            name
            sku
          }
        }
        user {
          name
          id
        }
        warehouse {
          name
          id
        }
      }
    }
  `;

  const variables = { where };

  const data = await client.request(query, variables);
  return data.damageDropdownCopy as IDamageGood[];
};

export const getExpenseTransactions = async (date: string, type: string) => {
  const query = gql`
    query ($date: String!, $type: String!) {
      findTransactionIdsByDate(
        input: {
          date: $date
          type: $type
        }
      )
    }
  `;
  const variables = { date, type };

  const data = await client.request(query, variables);
  return data.findTransactionIdsByDate;
};



export const deleteDamage = async (id: string) => {
  const mutation = gql`
    mutation ($input: deleteDamageCopyInput!) {
      deleteDamageCopy(input: $input) {
        damageCopy {
          id
        }
      }
    }
  `;

  const variables = {
    input: {
      where: { id },
    },
  };

  await client.request(mutation, variables);
};
